










































































































































import { defineComponent, ref } from '@vue/composition-api'
import * as nodeEmoji from 'node-emoji'

export default defineComponent({
  name: 'App',
  setup() {
    const showDefault = ref<boolean>(true)
    const showDemo = ref<boolean>(false)
    const randomEmoji = ref<string>(nodeEmoji.random().emoji)

    const toggleDemo = () => {
      if (showDefault.value) {
        showDefault.value = false
        randomEmoji.value = nodeEmoji.random().emoji
        setTimeout(() => (showDemo.value = true), 500)
      } else {
        showDemo.value = false
        randomEmoji.value = nodeEmoji.random().emoji
        setTimeout(() => (showDefault.value = true), 500)
      }
    }
    return {
      showDefault,
      showDemo,
      randomEmoji,
      toggleDemo,
    }
  },
})
